<template>
    <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

        <v-row no-gutters>

            <!-- NUMERIC RANGE START -->
            <v-col cols="6" v-if="!disableEdit" class="pr-2">

                <validation-provider
                        name="range start"
                        vid="start"
                        mode="lazy"
                        rules="required|numeric|range:end"
                        v-slot="{ errors }">

                    <v-text-field
                            label="Range start"
                            placeholder="Enter range end value"
                            v-model="rangeStartModel"
                            :error-messages="errors"
                            @keyup="emit()"
                            autocomplete="off"
                    >
                    </v-text-field>

                </validation-provider>
            </v-col>

            <!-- NUMERIC RANGE END -->
            <v-col cols="6" v-if="!disableEdit" class="pl-2">

                <validation-provider
                        name="range end"
                        vid="end"
                        mode="lazy"
                        rules="required|numeric"
                        v-slot="{ errors }">

                    <v-text-field
                            label="Range end"
                            placeholder="Enter range end value"
                            v-model="rangeEndModel"
                            :error-messages="errors"
                            @keyup="emit()"
                            autocomplete="off"
                    >
                    </v-text-field>

                </validation-provider>
            </v-col>
        </v-row>

        <v-row no-gutters v-if="disableEdit">

            <v-col cols="12" class="ml-2">
                From
                <v-chip class="mr-2"
                        text-color="white"
                        dark small
                        labelcrre
                        color="grey darken-1">
                    {{ rangeStartModel }}
                </v-chip>
                To
                <v-chip
                        text-color="white"
                        dark small
                        label
                        color="grey darken-1">
                    {{ rangeEndModel }}
                </v-chip>
            </v-col>

        </v-row>

    </validation-observer>

</template>

<script>

    import {extend} from 'vee-validate/dist/vee-validate.full';

    export default {

        props: {
            value: {
                required: false,
                type: Array,
                default: () => []
            },
            disableEdit: {
                required: false,
                type: Boolean,
                default: false,
            },
            color: {
                type: String,
                required: true,
            },
        },

        watch: {
            value(value) {
                this.rangeStartModel = value[0];
                this.rangeEndModel = value[1];
            },
        },

        data() {
            return {
                rangeStartModel: null,
                rangeEndModel: null,
            }
        },

        created() {
            extend('range', {
                validate: (value, {other}) => value < other,
                message: 'Range start must be smaller than Range end',
                params: [{name: 'other', isTarget: true}],
                lazy: true
            });

            this.rangeStartModel = this.value[0];
            this.rangeEndModel = this.value[1];
        },

        methods: {
            emit() {
                this.$refs.validationObserver.validate()
                    .then(isValid => {
                        if (isValid) {
                            this.$emit('input', [this.rangeStartModel, this.rangeEndModel]);
                        }
                    });
            }
        }
    }
</script>
